import axios from "../../config/axiosConfig";
import { RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_AVAILABLE_REQUEST, RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_AVAILABLE_REQUEST_FAILURE, GET_RAW_MATERIAL_INWARD_CHALLAN_TRANSACTIONS_AVAILABLE_TAKA_NO,
  GET_RAW_MATERIAL_INWARD_CHALLAN_AVAILABLE_TRANSACTIONS } from "../types";

export const getRawMaterialInwardChallanAvailableTransactions = (queryParams) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_AVAILABLE_REQUEST });
      const { auth } = getState();
      let params = { ...queryParams, customerId: auth?.user?.Customer_Id };
      console.log('>>>>>common production', auth?.company?.Common_Company);
      
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/raw-material-inward-challan/available-raw-material-inward-challan-transaction", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_RAW_MATERIAL_INWARD_CHALLAN_AVAILABLE_TRANSACTIONS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getRawMaterialInwardChallanAvailableTransactionTakaNo = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_AVAILABLE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/raw-material-inward-challan/available-raw-material-inward-challan-transaction", { params }).then((response) => {
        const takaNos = response.data.map((data) => data.Taka_No);
        if (response.data) {
          dispatch({ type: GET_RAW_MATERIAL_INWARD_CHALLAN_TRANSACTIONS_AVAILABLE_TAKA_NO, payload: takaNos });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });
    }
  };
};

